import { IUseMixpanelProps } from '.';

export default function combineTrackingData(
  newData: IUseMixpanelProps,
  oldData: IUseMixpanelProps | null
): IUseMixpanelProps {
  const patientUuid = newData?.patientUuid ?? oldData?.patientUuid;
  const screen = newData?.screen ?? oldData?.screen;
  const initData = {
    ...(oldData?.initData ?? {}),
    ...(newData.initData ?? {}),
  };
  return {
    patientUuid,
    screen,
    initData,
  };
}
